import { useMemo } from 'react';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import useChangePreview from '@/features/dashboard/bookingChanges/hooks/useChangePreview.ts';
import { bookingBillMapper } from '@/features/dashboard/bookingChanges/types/BookingBill.mapper.ts';
import { ParticipantBillVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';

/**
 * Ekran uczestnika (A1/A2): rachunek osoby złożony ze stanu bieżącego
 * i pozycji otwartego szkicu. Widok niesie obie wartości naraz, więc
 * przełączenie trybu podglądu i edycji nie wymaga ponownego pobrania danych.
 */
const useParticipantBillView = (
  bookingId: string | undefined,
  participantId: string | undefined,
) => {
  const billQuery = useBookingBill(bookingId);
  const draftQuery = useGetOpenDraft(bookingId);
  const previewQuery = useChangePreview(bookingId);

  const view: ParticipantBillVm | null = useMemo(() => {
    if (!billQuery.data || !participantId) {
      return null;
    }
    return bookingBillMapper.toParticipantView(
      billQuery.data,
      participantId,
      draftQuery.data?.items ?? [],
      previewQuery.preview,
    );
  }, [billQuery.data, draftQuery.data, previewQuery.preview, participantId]);

  return {
    view,
    isLoading:
      billQuery.isLoading || draftQuery.isLoading || previewQuery.isLoading,
    isError: billQuery.isError || draftQuery.isError,
  };
};

export default useParticipantBillView;
